<template>
    <div id="app_footer" class="grc_fullwidth_lane Footer_lane" style="padding-right:0px;">

        <div class="Footer_image_cont">
            &nbsp;
        </div>

        <div class="grc_fullwidth_lane Footer_lane2">
            <div class="Footer_table">
                <div class="Footer_row">
                    <div class="footer_col">
                        <img src="../../../public/styles/images/eplogo_white_tr.svg" style="width:100%; max-width:300px;" />
                    </div>
                    <div class="footer_col">
                        <div class="footer_col_header">Kapcsolat</div>

                        PRÉMIUM Egészségpénztár
                        <br>1138 Budapest, Dunavirág u. 2-6
                        <br>
                        <br>+ 36 1 999 9696
                        <br>
                        <br><a class="link_jogdok" href="mailto:kapcsolat@premiumpenztarak.hu">kapcsolat@premiumpenztarak.hu</a>
                    </div>
                    <div class="footer_col">
                        <div class="footer_col_header">Számlaszám befizetéshez</div>

                        UniCredit:
                        <br>10918001-00000005-06060007
                        <br>
                        <br>Adószám:
                        <br>18177734-2-41

                    </div>
                    <div class="footer_col">
                        <div class="footer_col_header">Közérdekű</div>
                        <span v-html="footer_links"></span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>

export default {
  name: 'AppFooter',
  components: {
  },
  data () {
      return {
          footer_links:"",

          bgcolor:"transparent",

      }
  },
  model: {

  },  
  methods:{

    ChangeBackgroundColor(pColor)
    {
        this.bgcolor = pColor;
    },

  },
  created()
  {
    
  },

  mounted()
  {
        this.footer_links='<a class="link_jogdok" href="https://premiumegeszsegpenztar.hu/jognyilatkozat?mtb=yes" target="_blank">Jognyilatkozat</a>';
        this.footer_links = this.footer_links + '<br><a class="link_jogdok" href="https://premiumegeszsegpenztar.hu/adatkezelesi-tajekoztato?mtb=yes" target="_blank">Adatkezelési tájékoztató</a>';
  }

}


</script>


<style scoped>
    .Footer_lane
    {
        width:100%; 
        position: absolute;
        bottom: 0px;
        padding-top: 0px;
        box-sizing: border-box;
        color:#fff;
        min-height: 290px;
    }

    .Footer_lane2
    {
        width:100%; 
        box-sizing: border-box;
        padding-bottom: 20px;
        /* background-color: #005971; */
        /* background-image: url(../../../public/styles/images/footer_pattern.png); */
        background-image: url(../../../public/styles/images/bgfooter.png);
        min-height: 280px;
    }

    .Footer_lane2_2
    {
        width:100%; 
        box-sizing: border-box;
        /*
        background-color: #005971;
        opacity:0.9;
        */
    }

    .Footer_image_cont
    {
        width:100%;
        box-sizing: border-box;
        /* background-color:#fff; */
        text-align: center;
        display: flex;
        height:40px;
    }

    .Footer_image
    {
        width:90%;
        max-width: 950px;
        margin-left:auto;
        margin-right:auto;
    }

    .Footer_table
    {
        font-family: "PremiumDefault", Verdana;
        font-size: 14px;
        line-height: 20px;
        width:100%;
        box-sizing: border-box;
        display:inline-block;
    }

    .Footer_row
    {
        display:inline-block;
        width:100%;
        box-sizing: border-box;
    }

    .Footer_jog
    {
        font-family: "PremiumDefault", Verdana;
        font-size: 16px;
        line-height: 16px;
        width:100%;
        box-sizing: border-box;
        padding-top: 20px;
        padding-bottom: 10px;
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
    }


    >>> .link_jogdok
    {
        color:#fff;
        text-decoration: underline;
        outline: none;
    }

    >>> .link_jogdok:visited
    {
        color:#fff;
        text-decoration: underline;
        outline: none;
    }

    >>> .link_jogdok:hover
    {
        color:#fff;
        text-decoration: underline;
        outline: none;
    }


    .footer_col
    {
        display:inline-block;
        vertical-align: top;
        padding-top: 20px;
        padding-left:20px;
        padding-right: 20px;
        box-sizing: border-box;
        width:25%;
        margin:0px;
    }
    
    .footer_col_header
    {
        width:100%;
        box-sizing: border-box;
        font-weight: 500;
        font-size:16px;
        padding: 4px 0px;
        border-bottom: solid 2px #6b9eac;
        margin-bottom: 14px;        
    }

    @media (max-width:1100px)
    {
        .footer_col
        {
            width:50%;
        }
    }


    @media (max-width:600px)
    {
        .footer_col
        {
            width:100%;
        }

        .Footer_lane
        {
            position: relative
        }

        .maincontentbox
        {
            padding-bottom: 20px;
        }


    }



</style>